import { pick } from "./locale";
import { useMessages } from "./LocaleProvider";
import { PORTAL_COPY, type PortalCopyKey } from "./portalCopy";

/**
 * `t()` for the portal-local copy in `./portalCopy.ts`. Deliberately a SECOND hook rather
 * than a widened `useMessages().t`: a call site reads `c("link.failed")` and it is obvious
 * that the string is this client's, not a shared domain term the API also uses.
 */
export function usePortalCopy(): (key: PortalCopyKey) => string {
  const { locale } = useMessages();
  return (key) => pick(PORTAL_COPY[key], locale);
}
